export default "__VITE_ASSET__Msz7eaA2__"